import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";
import { FieldPath, FieldValues, UseFormRegister } from "react-hook-form";

interface IProps<TFieldValues extends FieldValues = FieldValues, TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>> {
    id?: string;
    name: TFieldName;
    register: UseFormRegister<TFieldValues>;
}

type Props<TFieldValues extends FieldValues = FieldValues, TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>>
    = IProps<TFieldValues, TFieldName> & Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, "name" | "onChange" | "onBlur">;

export function HiddenField<TFieldValues extends FieldValues = FieldValues, TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>>({
    id,
    name,
    register,
    ...props
}: Props<TFieldValues, TFieldName>) {
    return <input
        id={id}
        type="hidden"
        data-testid="hiddenField"
        {...props}
        {...register(name)}
    />;
}
